module.exports = __webpack_public_path__ + "static/media/home7.7a3695f7.jpg";